var SDK_VERSION = '7.11.1';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
